/**
 * OVERRIDE App.jsx
 */

import App from '../../../../components/App/App';

export default App;